"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const index_1 = require("../index");
function EditGroup({ group }) {
    const sharingService = (0, hooks_1.useSharing)();
    const [isSaved, setIsSaved] = (0, react_1.useState)(false);
    if (!group) {
        return null;
    }
    const onSaveInfo = ({ name, avatar, information }) => {
        const payload = { name, description: information };
        if (avatar)
            payload.image = avatar;
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.update(group.identifier, Object.assign({}, payload)).then(() => {
            setIsSaved(true);
        });
    };
    return ((0, jsx_runtime_1.jsx)(index_1.GroupEditPopupCommon, { group: group, onSaveInfo: onSaveInfo, isSaved: isSaved, setIsSaved: setIsSaved, "data-e2e": 'EditGroup_GroupEditPopupCommon' }));
}
exports.default = EditGroup;
